import { CalendarClock } from '@orgus/ui/icons';
import { OnCallSettings } from '../../notify/OnCallSettings.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'on-call',
  title: 'On call',
  description: 'People, rotas, quiet hours and escalation.',
  order: 20,
  group: 'alerts',
  keywords: ['rota', 'escalation', 'pager', 'on call'],
  icon: CalendarClock,
  Component: OnCallSettings,
  needs: { module: '/api/notify/members', feature: 'On call', instead: 'Push, Slack and Teams alerts reach everyone you add in Settings, Notifications.' },
};
export default section;
